// Company: TechBolic Solutions
// VERSION: 1.0.0
// Website: https://techbolic.com/

import initializeFormWizard from "../../frontend/shared/form_wizard";
import initializeFormValidations from "../../frontend/shared/form_validations";
import initializeMaxLength from "../../frontend/shared/max_length";
import initializePasswordValidation from "../../frontend/shared/password_validation";
import hideModal from "../../frontend/shared/hide_modal";
import displayModal from "../../frontend/shared/display_modal";
import initializeWithdrawalConsentButtons from "../../frontend/shared/withdrawal_consent_modal";
import initializeLazyLoad from "../../frontend/shared/lazyload";

window.initializePage = () => {
  initializeFormWizard();
  initializeFormValidations();
  initializeMaxLength();
  initializePasswordValidation();
  initializeLazyLoad();
};

window.hideModal = hideModal;
window.displayModal = displayModal;
window.initializeWithdrawalConsentButtons = initializeWithdrawalConsentButtons;
